(() => {
  const sectionSelector = '.ng-home-etsy-reviews';
  const maxAttempts = 40;
  const retryDelay = 500;

  const removeTrailingPunctuation = (element) => {
    element.querySelectorAll('p').forEach((paragraph) => {
      const textNodes = [];
      const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
      let node;

      while ((node = walker.nextNode())) textNodes.push(node);

      const lastTextNode = textNodes.reverse().find((textNode) => /\S/u.test(textNode.nodeValue));
      if (lastTextNode) {
        lastTextNode.nodeValue = lastTextNode.nodeValue.replace(/[.,;:!?，。；：！？]+(\s*)$/u, '$1');
      }
    });
  };

  const makeClone = (card, hidden) => {
    const clone = card.cloneNode(true);

    if (hidden) {
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
    }

    return clone;
  };

  const createReviewRow = (cards, direction) => {
    const row = document.createElement('div');
    const track = document.createElement('div');
    const firstGroup = document.createElement('div');
    const secondGroup = document.createElement('div');

    row.className = `ng-home-etsy-reviews__marquee-row ng-home-etsy-reviews__marquee-row--${direction}`;
    track.className = 'ng-home-etsy-reviews__marquee-track';
    firstGroup.className = 'ng-home-etsy-reviews__marquee-group';
    secondGroup.className = 'ng-home-etsy-reviews__marquee-group';

    cards.forEach((card) => {
      const visibleCopy = makeClone(card, false);
      const duplicateCopy = makeClone(card, true);

      visibleCopy.classList.add('ng-home-etsy-reviews__marquee-card');
      duplicateCopy.classList.add('ng-home-etsy-reviews__marquee-card');
      firstGroup.append(visibleCopy);
      secondGroup.append(duplicateCopy);
    });

    track.append(firstGroup, secondGroup);
    row.append(track);

    return row;
  };

  const initialiseSection = (section) => {
    if (section.dataset.ngEtsyReviewsInitialised || section.querySelector('.ng-home-etsy-reviews__marquee')) return true;

    const header = section.querySelector('.reputon-reviews-head');
    const reviewGrid = section.querySelector('.reputon-body');
    const cards = Array.from(section.querySelectorAll('.reputon-body .reputon-card:not(.reputon-Summary)'));

    if (!header || !reviewGrid || cards.length < 2) return false;

    const summary = reviewGrid.querySelector('.reputon-card.reputon-Summary');
    const themeLogo = document.querySelector('.m-header .m-logo__img, .m-logo__img');
    if (themeLogo?.currentSrc || themeLogo?.src) {
      const brandLogo = document.createElement('img');
      brandLogo.className = 'ng-home-etsy-reviews__brand-logo';
      brandLogo.src = themeLogo.currentSrc || themeLogo.src;
      brandLogo.alt = 'NextGenBoba';
      brandLogo.width = 56;
      brandLogo.height = 56;
      header.querySelector('.ng-home-etsy-reviews__brand-logo')?.remove();
      header.insertBefore(brandLogo, header.firstChild);
    }

    if (summary) {
      const summaryCopy = makeClone(summary, false);
      removeTrailingPunctuation(summaryCopy);
      summaryCopy.classList.add('ng-home-etsy-reviews__summary');
      header.querySelector('.ng-home-etsy-reviews__summary')?.remove();
      header.append(summaryCopy);
      header.classList.add('ng-home-etsy-reviews__rating--with-summary');
    }

    const rows = [cards.filter((_, index) => index % 2 === 0), cards.filter((_, index) => index % 2 === 1)];
    const marquee = document.createElement('div');

    marquee.className = 'ng-home-etsy-reviews__marquee';
    marquee.setAttribute('aria-label', 'Customer reviews');
    marquee.append(createReviewRow(rows[0], 'forward'), createReviewRow(rows[1], 'reverse'));
    reviewGrid.after(marquee);
    section.classList.add('ng-home-etsy-reviews--marquee-ready');
    section.dataset.ngEtsyReviewsInitialised = 'true';
    return true;
  };

  const start = () => {
    document.querySelectorAll(sectionSelector).forEach((section) => {
      let attempts = 0;
      const tryInitialise = () => {
        attempts += 1;
        if (!initialiseSection(section) && attempts < maxAttempts) setTimeout(tryInitialise, retryDelay);
        else if (!section.classList.contains('ng-home-etsy-reviews--marquee-ready')) {
          section.classList.add('ng-home-etsy-reviews--fallback');
        }
      };

      tryInitialise();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
